<template>
  <div>
    <source-layer
      v-model="sourceLayerType"
      :validated="validated"
    ></source-layer>
    <reference-layer
      v-model="referenceLayerId"
      :reference-layers="referenceLayers"
      :showErrorInfo="validated && referenceLayerIsEmpty"
    ></reference-layer>
    <b-row v-if="showResult" class="mt-2">
      <b-col offset="3" cols="9">
        <span
          ><strong>Wynik: {{ result }} obiektów.</strong></span
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SourceLayer from './SourceLayer';
import ReferenceLayer from './ReferenceLayer';
import { Api as ApiAnalysis } from '../../api/api-analizy';
import { WINDOW_NOTIFICATION_SHOW } from '../../store/mutations.type';

export default {
  components: {
    SourceLayer,
    ReferenceLayer
  },
  data() {
    return {
      sourceLayerType: null,
      referenceLayerId: null,
      validated: false,
      result: null,
      waitingForResponse: Boolean
    };
  },
  props: {
    referenceLayers: { type: Array, default: () => [] },
    hasErrors: { type: Boolean, default: false }
  },
  computed: {
    sourceLayerTypeIsEmpty() {
      return !this.sourceLayerType;
    },
    referenceLayerIsEmpty() {
      return !this.referenceLayerId;
    },
    formHasErrors() {
      return this.sourceLayerTypeIsEmpty || this.referenceLayerIsEmpty;
    },
    showResult() {
      return this.result !== null;
    }
  },
  watch: {
    formHasErrors(value) {
      this.$emit('update:hasErrors', value);
    }
  },
  methods: {
    async submit() {
      this.validated = true;

      if (!this.formHasErrors) {
        const data = {
          analiza_filter: {
            typ_analizy: 'zawieraja',
            typ_wejsciowych: this.referenceLayerId.type,
            warstwa_id: this.referenceLayerId.id,
            features_geojson: this.referenceLayerId.geojson
          },
          warstwa_id: this.$store.getters.featuresLayer.id
        };

        if (this.sourceLayerType.type === 'selection') {
          data.analiza_filter.feature_ids_filter = [
            ...this.$store.getters.selectedMapFeatures
          ];

          if (!data.analiza_filter.feature_ids_filter.length) {
            this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
              type: 'warn',
              title: 'Uwaga. Nie zaznaczono obiektów.',
              message:
                'Nie można wykonać analizy z powodu braku zaznaczonych obiektów.',
              duration: 5000
            });

            return;
          }
        }

        try {
          this.$emit('update:waitingForResponse', true);
          const api = new ApiAnalysis();
          const response = await api.postAnalizyZliczaniaIlosciAnaliza({
            wso2_id: this.contextEmail ? this.contextEmail : null,
            orgid: this.contextOrganizationId
              ? this.contextOrganizationId
              : null,
            body: data
          });
          this.result = response.body.wynik.ilosc;
        } catch (e) {
          this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'error',
            title: 'Uwaga. Analiza nie powiodła się.',
            message: 'Analiza nie powiodła się.',
            duration: 5000
          });
        } finally {
          this.$emit('update:waitingForResponse', false);
        }
      } else {
        this.$emit('update:hasErrors', true);
      }
    }
  }
};
</script>
